import { render, staticRenderFns } from "./NotExpert.vue?vue&type=template&id=4871d83e&scoped=true&"
import script from "./NotExpert.vue?vue&type=script&lang=js&"
export * from "./NotExpert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4871d83e",
  null
  
)

export default component.exports